export default {"src":"/_next/static/media/facebook.dc489f8b.svg","height":16,"width":10};